import * as React from 'react';
import { AppContext } from '../../App';
import { ITrainingSet } from '../../types/my-types';
import { Link } from 'react-router';
import { getIdFromUrl } from '../../utils/getIdFromUrl';

import { Divider } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DrawIcon from '@mui/icons-material/Draw';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuItemHiddenTextLabel from '../common/MenuItemHiddenTextLabel';
import TrainingSetDelete from './actions/TrainingSetDelete';

interface TrainingSetTableRowActionsProps {
  trainingSet: ITrainingSet;
}

const TrainingSetTableRowActions: React.FC<TrainingSetTableRowActionsProps> = ({ trainingSet }) => {
  const { dataPoolId } = React.useContext(AppContext);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const firstDocId = getIdFromUrl(trainingSet?.documents[0]);

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        data-cy={`btn-training-set-row-actions-${trainingSet.label}`}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          key={'ts-tablerow-actions-review'}
          data-cy={`btn-training-set-mark-${trainingSet.label}`}
          component={Link}
          to={`/data-pools/${dataPoolId}/train/${trainingSet.id}/mark/${firstDocId}`}
          onClick={(event) => {
            handleClose();
          }}
          onAuxClick={handleClose}
          sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
        >
          <ListItemIcon>
            <DrawIcon fontSize="small" />
          </ListItemIcon>
          <MenuItemHiddenTextLabel>Mark</MenuItemHiddenTextLabel>
        </MenuItem>

        <MenuItem
          key={'ts-tablerow-actions-fields'}
          data-cy={`tab-ts-fields-${trainingSet.label}`}
          component={Link}
          to={`/data-pools/${dataPoolId}/train/${trainingSet.id}/fields`}
          onClick={(event) => {
            handleClose();
          }}
          onAuxClick={handleClose}
          sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
        >
          <ListItemIcon>
            <FormatListBulletedIcon fontSize="small" />
          </ListItemIcon>
          <MenuItemHiddenTextLabel>Fields</MenuItemHiddenTextLabel>
        </MenuItem>

        <MenuItem
          key={'ts-tablerow-actions-details'}
          data-cy={`btn-training-set-actions-details-${trainingSet.label}`}
          component={Link}
          to={`/data-pools/${dataPoolId}/train/${trainingSet.id}/details`}
          onClick={(event) => {
            handleClose();
          }}
          onAuxClick={handleClose}
          sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
        >
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <MenuItemHiddenTextLabel>Details</MenuItemHiddenTextLabel>
        </MenuItem>

        <Divider />
        <TrainingSetDelete trainingSetId={trainingSet.id} type="menu" />
      </Menu>
    </div>
  );
};

export default TrainingSetTableRowActions;
